import { MinimalOrganization } from '../models/organization/minimal-organization.interface';

const OrgTitleFilter: (
  org: MinimalOrganization,
  term: string,
) => boolean = (org, term) =>
  org?.title.toLowerCase().includes(term.toLowerCase());

const OrgFormatter: (
  org: MinimalOrganization | null | undefined,
) => string = (org) => org?.title ?? '';

const OrgCompareFn: (
  org: MinimalOrganization,
  value: MinimalOrganization,
) => boolean = (org, value) => org.title === value.title;

export const OrganizationSearchConfig = {
  filterFn: OrgTitleFilter,
  formatter: OrgFormatter,
  compareFn: OrgCompareFn,
};